<!-- マッチングスコア候補とキーワード軸候補の間の仕切り -->
<!-- ループ中のメールに紐づくスコアが存在せず、一個前のメールに紐づくスコアが存在または、一個前のメールが存在しない時に表示 -->
<span class="filter-rule-flag" *ngIf="show">{{text}}</span>
